export class GetUserResponse {
  currentUsers: CurrentUsers[];
  availableRoles: AvailableRole[];
}

export class CurrentUsers {
  createdBy: string;
  createdDate: string;
  dealerId: string;
  emailAddress: string;
  fullName: string;
  isActive: string;
  languageId: string;
  roles: AvailableRole[];
  updatedDate: string;
  userId: string;
  userName: string;
}

export class AvailableRole {
  id: string;
  name: string;
}
